<template>
  <div>
    <!-- 头部 start -->
<top />
    <!-- banner -->
    <div class="banner">
      <img class="banner-img" src="@/assets/images/banner/banner1.jpg" alt="">
      <img class="banner-slogan contact-slogan" src="@/assets/images/banner/img_fontcooperation.png" alt="">
    </div>
    <!-- 分类 -->
    <cooperate-type/>
    <!-- form -->
    <div id="type1">
        <apply-form/>
    </div>
    

    <!-- 校园合作 -->
    <div id="type2"><campus-cooperate/></div>    
    
    <!-- 校企合作 -->
    <div id="type3">
    <union-cooperate/>
    </div>  
    
    <bottom />
  </div>
</template>

<script>
import { defineComponent,ref } from 'vue'
import Top from "@/components/common/Top.vue";
import CooperateType from '@/components/apply/CooperateType.vue'
import CampusCooperate from '@/components/apply/CampusCooperate.vue'
import UnionCooperate from '@/components/apply/UnionCooperate.vue'
import applyForm from './applyForm.vue'
import Bottom from "@/components/common/Bottom.vue";
export default defineComponent({
 setup(){
     
     return{ 
        
     }
 },
 components:{
     Bottom,
     CooperateType,
     CampusCooperate,
     UnionCooperate,
     applyForm,
     Top
 }
})
</script>

<style lang="scss" scoped type="text/scss">

</style>
